module.exports = __webpack_public_path__ + "static/media/x.b0200bf7.svg";